import { cn } from '@/lib/cn'

export interface SkeletonProps {
  className?: string
}

export function Skeleton({ className }: SkeletonProps) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-md bg-surface-hover', className)} />
}

/**
 * Sized to match TrackRow exactly (h-16, 40px cover, two text lines) so the real
 * list drops in without shifting a single pixel.
 */
export function TrackRowSkeleton() {
  return (
    <div className="flex h-16 items-center gap-3 px-2">
      <Skeleton className="h-10 w-10 shrink-0 rounded-md" />
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <Skeleton className="h-3.5 w-1/2 max-w-56" />
        <Skeleton className="h-3 w-1/3 max-w-40" />
      </div>
      <Skeleton className="h-3 w-9 shrink-0" />
    </div>
  )
}

export function TrackListSkeleton({ count = 8 }: { count?: number }) {
  return (
    <div role="status" aria-label="Loading songs">
      {Array.from({ length: count }, (_, index) => (
        <TrackRowSkeleton key={index} />
      ))}
    </div>
  )
}
